import { render, staticRenderFns } from "./AddBillOfLanding.vue?vue&type=template&id=0ba7e3ea&scoped=true&"
import script from "./AddBillOfLanding.vue?vue&type=script&lang=js&"
export * from "./AddBillOfLanding.vue?vue&type=script&lang=js&"
import style0 from "./AddBillOfLanding.vue?vue&type=style&index=0&id=0ba7e3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba7e3ea",
  null
  
)

export default component.exports